//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheRadarFiftyBadge",

  props: {
    styles: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    computedStyles() {
      return {
        ...this.styles
      };
    },
  },
}
